var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertInProgressImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_160793",
    "data-name": "Group 160793",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 222.456,
    height: 193.653,
    viewBox: "0 0 222.456 193.653",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147947",
    "data-name": "Rectangle 147947",
    width: 222.456,
    height: 193.653,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160792",
    "data-name": "Group 160792",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38507",
    "data-name": "Path 38507",
    d: "M212.968,277.66c0,3.518-30.685,6.37-68.537,6.37s-68.538-2.852-68.538-6.37,30.685-6.37,68.538-6.37,68.537,2.852,68.537,6.37",
    transform: "translate(-27.922 -99.812)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147889",
    "data-name": "Rectangle 147889",
    width: 38.174,
    height: 42.872,
    transform: "translate(97.421 133.39)",
    fill: "#5aa0f1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147890",
    "data-name": "Rectangle 147890",
    width: 38.174,
    height: 14.901,
    transform: "translate(97.421 133.39)",
    fill: "#3a66b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38508",
    "data-name": "Path 38508",
    d: "M199.287,274.4H127.679V269.65a7.233,7.233,0,0,1,7.233-7.233h57.142a7.233,7.233,0,0,1,7.233,7.233Z",
    transform: "translate(-46.975 -96.547)",
    fill: "#3a66b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38509",
    "data-name": "Path 38509",
    d: "M221.619,138.328H23.693a6.984,6.984,0,0,1-6.985-6.985V6.984A6.985,6.985,0,0,1,23.693,0H221.619A6.985,6.985,0,0,1,228.6,6.984v124.36a6.985,6.985,0,0,1-6.985,6.985",
    transform: "translate(-6.147 0)",
    fill: "#5aa0f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38510",
    "data-name": "Path 38510",
    d: "M25.581,133.168V11.689A2.817,2.817,0,0,1,28.4,8.872H223.443a2.816,2.816,0,0,1,2.816,2.817V133.168a2.817,2.817,0,0,1-2.817,2.817H28.4a2.816,2.816,0,0,1-2.817-2.816",
    transform: "translate(-9.412 -3.264)",
    fill: "#c7d2d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38511",
    "data-name": "Path 38511",
    d: "M111.034,96.712H49.666a1.393,1.393,0,0,1-1.392-1.392V52.728a1.393,1.393,0,0,1,1.392-1.392h61.367a1.392,1.392,0,0,1,1.392,1.392V95.319a1.392,1.392,0,0,1-1.392,1.392",
    transform: "translate(-17.761 -18.887)",
    fill: "#3a66b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38512",
    "data-name": "Path 38512",
    d: "M49.836,96.61V58.267a1.1,1.1,0,0,1,1.1-1.1h59.982a1.1,1.1,0,0,1,1.1,1.1V96.61a1.1,1.1,0,0,1-1.1,1.1H50.933a1.1,1.1,0,0,1-1.1-1.1",
    transform: "translate(-18.335 -21.034)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38513",
    "data-name": "Path 38513",
    d: "M146.418,53.727a.907.907,0,1,1-.906-.906.906.906,0,0,1,.906.906",
    transform: "translate(-53.202 -19.434)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38514",
    "data-name": "Path 38514",
    d: "M141.68,53.727a.907.907,0,1,1-.906-.906.906.906,0,0,1,.906.906",
    transform: "translate(-51.459 -19.434)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38515",
    "data-name": "Path 38515",
    d: "M136.941,53.727a.907.907,0,1,1-.906-.906.906.906,0,0,1,.906.906",
    transform: "translate(-49.716 -19.434)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38516",
    "data-name": "Path 38516",
    d: "M61.11,66.517a3.665,3.665,0,1,1-3.665-3.665,3.666,3.666,0,0,1,3.665,3.665",
    transform: "translate(-19.786 -23.124)",
    fill: "#3a66b4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147891",
    "data-name": "Rectangle 147891",
    width: 47.214,
    height: 1.731,
    transform: "translate(43.008 39.756)",
    fill: "#ccfffd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147892",
    "data-name": "Rectangle 147892",
    width: 29.757,
    height: 1.731,
    transform: "translate(43.007 42.527)",
    fill: "#ccfffd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147893",
    "data-name": "Rectangle 147893",
    width: 19.342,
    height: 1.731,
    transform: "translate(43.007 45.468)",
    fill: "#ccfffd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38517",
    "data-name": "Path 38517",
    d: "M61.11,84.983a3.665,3.665,0,1,1-3.665-3.665,3.665,3.665,0,0,1,3.665,3.665",
    transform: "translate(-19.786 -29.918)",
    fill: "#5aa0f1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147894",
    "data-name": "Rectangle 147894",
    width: 47.214,
    height: 1.731,
    transform: "translate(43.008 51.429)",
    fill: "#ccfffd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147895",
    "data-name": "Rectangle 147895",
    width: 29.757,
    height: 1.731,
    transform: "translate(43.007 54.199)",
    fill: "#ccfffd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147896",
    "data-name": "Rectangle 147896",
    width: 19.342,
    height: 1.731,
    transform: "translate(43.007 57.141)",
    fill: "#ccfffd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38518",
    "data-name": "Path 38518",
    d: "M61.11,103.45a3.665,3.665,0,1,1-3.665-3.665,3.665,3.665,0,0,1,3.665,3.665",
    transform: "translate(-19.786 -36.712)",
    fill: "#8bf6f1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147897",
    "data-name": "Rectangle 147897",
    width: 47.214,
    height: 1.731,
    transform: "translate(43.008 63.102)",
    fill: "#ccfffd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147898",
    "data-name": "Rectangle 147898",
    width: 29.757,
    height: 1.731,
    transform: "translate(43.007 65.872)",
    fill: "#ccfffd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147899",
    "data-name": "Rectangle 147899",
    width: 19.342,
    height: 1.731,
    transform: "translate(43.007 68.814)",
    fill: "#ccfffd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38519",
    "data-name": "Path 38519",
    d: "M212.145,168.831H158.413a1.424,1.424,0,0,1-1.424-1.423v-36.45a1.424,1.424,0,0,1,1.424-1.423h53.732a1.423,1.423,0,0,1,1.423,1.423v36.45a1.423,1.423,0,0,1-1.423,1.423",
    transform: "translate(-57.759 -47.657)",
    fill: "#3a66b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38520",
    "data-name": "Path 38520",
    d: "M158.342,168.79v-33.3a.9.9,0,0,1,.9-.9h53.062a.9.9,0,0,1,.9.9v33.3a.9.9,0,0,1-.9.9H159.246a.9.9,0,0,1-.9-.9",
    transform: "translate(-58.256 -49.517)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38521",
    "data-name": "Path 38521",
    d: "M243.6,131.605a.785.785,0,1,1-.785-.785.785.785,0,0,1,.785.785",
    transform: "translate(-89.047 -48.131)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38522",
    "data-name": "Path 38522",
    d: "M239.5,131.605a.785.785,0,1,1-.785-.785.785.785,0,0,1,.785.785",
    transform: "translate(-87.537 -48.131)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38523",
    "data-name": "Path 38523",
    d: "M235.4,131.605a.785.785,0,1,1-.785-.785.785.785,0,0,1,.785.785",
    transform: "translate(-86.028 -48.131)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38524",
    "data-name": "Path 38524",
    d: "M205.152,157.614A8.151,8.151,0,1,1,197,149.463a8.151,8.151,0,0,1,8.151,8.151",
    transform: "translate(-69.481 -54.99)",
    fill: "#5aa0f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38525",
    "data-name": "Path 38525",
    d: "M204.9,159.822,201.122,162l-3.773,2.179v-8.714l3.773,2.179Z",
    transform: "translate(-72.608 -57.198)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147900",
    "data-name": "Rectangle 147900",
    width: 54.87,
    height: 1.08,
    transform: "translate(100.085 116.498)",
    fill: "#ccfffd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147901",
    "data-name": "Rectangle 147901",
    width: 12.361,
    height: 1.08,
    transform: "translate(100.086 116.498)",
    fill: "#8bf6f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38526",
    "data-name": "Path 38526",
    d: "M178.245,184.679a.829.829,0,1,1-.829-.829.829.829,0,0,1,.829.829",
    transform: "translate(-64.969 -67.641)",
    fill: "#8bf6f1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147902",
    "data-name": "Rectangle 147902",
    width: 25.872,
    height: 25.872,
    rx: 7.151,
    transform: "translate(31.684 92.296)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.896
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147903",
    "data-name": "Rectangle 147903",
    width: 25.872,
    height: 25.872,
    rx: 7.151,
    transform: "translate(66.614 91.966)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.896
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38527",
    "data-name": "Path 38527",
    d: "M62.038,160.563l-3.727,3.727,3.756,3.756",
    transform: "translate(-21.453 -59.073)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.672
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38528",
    "data-name": "Path 38528",
    d: "M76.96,160.563l3.727,3.727-3.756,3.756",
    transform: "translate(-28.304 -59.073)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.672
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_307",
    "data-name": "Line 307",
    x1: 3.491,
    y2: 7.484,
    transform: "translate(42.875 101.49)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.672
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147904",
    "data-name": "Rectangle 147904",
    width: 41.862,
    height: 34.461,
    rx: 4.913,
    transform: "translate(162.668 34.314)",
    fill: "#3a66b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38529",
    "data-name": "Path 38529",
    d: "M318.923,56.79a.766.766,0,1,1-.766-.766.766.766,0,0,1,.766.766",
    transform: "translate(-116.773 -20.612)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38530",
    "data-name": "Path 38530",
    d: "M314.918,56.79a.766.766,0,1,1-.766-.766.766.766,0,0,1,.766.766",
    transform: "translate(-115.299 -20.612)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38531",
    "data-name": "Path 38531",
    d: "M310.913,56.79a.766.766,0,1,1-.766-.766.766.766,0,0,1,.766.766",
    transform: "translate(-113.826 -20.612)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38532",
    "data-name": "Path 38532",
    d: "M298.864,62.926V87.8a2.443,2.443,0,0,1-2.444,2.444H261.115a2.444,2.444,0,0,1-2.443-2.444V62.926a2.444,2.444,0,0,1,2.443-2.444H296.42a2.443,2.443,0,0,1,2.444,2.444",
    transform: "translate(-95.169 -22.252)",
    fill: "#8bf6f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38533",
    "data-name": "Path 38533",
    d: "M311.815,69.526A5.825,5.825,0,1,1,305.99,63.7a5.825,5.825,0,0,1,5.825,5.825",
    transform: "translate(-110.435 -23.437)",
    fill: "#5aa0f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38534",
    "data-name": "Path 38534",
    d: "M282.3,94.152H261.116a2.445,2.445,0,0,1-2.444-2.444V87.793l9.27-16.056a1.258,1.258,0,0,1,2.18,0l7,12.122,5.2,9a1.234,1.234,0,0,1-.021,1.29",
    transform: "translate(-95.169 -26.161)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38535",
    "data-name": "Path 38535",
    d: "M298.71,98.016H278.454L284.4,87.722l3.2-5.547a1.133,1.133,0,0,1,1.963,0Z",
    transform: "translate(-102.447 -30.025)",
    fill: "#f0f4ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147905",
    "data-name": "Rectangle 147905",
    width: 48.033,
    height: 3.825,
    transform: "translate(100.706 37.323)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147906",
    "data-name": "Rectangle 147906",
    width: 13.803,
    height: 1.913,
    transform: "translate(100.706 44.369)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147907",
    "data-name": "Rectangle 147907",
    width: 5.602,
    height: 1.913,
    transform: "translate(116.393 44.369)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147908",
    "data-name": "Rectangle 147908",
    width: 14.7,
    height: 1.913,
    transform: "translate(124.147 44.369)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147909",
    "data-name": "Rectangle 147909",
    width: 8.732,
    height: 1.913,
    transform: "translate(140.008 44.369)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147910",
    "data-name": "Rectangle 147910",
    width: 18.196,
    height: 1.913,
    transform: "translate(100.706 49.137)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147911",
    "data-name": "Rectangle 147911",
    width: 7.081,
    height: 1.913,
    transform: "translate(120.92 49.137)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147912",
    "data-name": "Rectangle 147912",
    width: 7.081,
    height: 1.913,
    transform: "translate(129.615 49.137)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147913",
    "data-name": "Rectangle 147913",
    width: 8.991,
    height: 1.913,
    transform: "translate(137.789 49.137)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147914",
    "data-name": "Rectangle 147914",
    width: 5.064,
    height: 1.913,
    transform: "translate(100.707 53.905)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147915",
    "data-name": "Rectangle 147915",
    width: 9.098,
    height: 1.913,
    transform: "translate(124.46 53.905)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147916",
    "data-name": "Rectangle 147916",
    width: 15.999,
    height: 1.913,
    transform: "translate(106.937 53.905)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147917",
    "data-name": "Rectangle 147917",
    width: 11.473,
    height: 1.913,
    transform: "translate(100.706 58.673)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147918",
    "data-name": "Rectangle 147918",
    width: 3.854,
    height: 1.913,
    transform: "translate(114.152 58.673)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147919",
    "data-name": "Rectangle 147919",
    width: 7.574,
    height: 1.913,
    transform: "translate(119.799 58.673)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147920",
    "data-name": "Rectangle 147920",
    width: 11.473,
    height: 1.913,
    transform: "translate(135.406 53.461)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147921",
    "data-name": "Rectangle 147921",
    width: 4.392,
    height: 1.913,
    transform: "translate(100.706 63.441)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147922",
    "data-name": "Rectangle 147922",
    width: 9.636,
    height: 1.913,
    transform: "translate(106.757 63.441)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147923",
    "data-name": "Rectangle 147923",
    width: 4.392,
    height: 1.913,
    transform: "translate(129.614 58.673)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147924",
    "data-name": "Rectangle 147924",
    width: 9.636,
    height: 1.913,
    transform: "translate(135.665 58.673)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38536",
    "data-name": "Path 38536",
    d: "M290.846,161.349H279.366v-.57h10.91v-10.91h.57Z",
    transform: "translate(-102.783 -55.139)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38537",
    "data-name": "Path 38537",
    d: "M261.773,143.186h-.57V131.7h11.481v.57h-10.91Z",
    transform: "translate(-96.1 -48.456)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147925",
    "data-name": "Rectangle 147925",
    width: 12.125,
    height: 12.125,
    transform: "translate(170.52 88.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147926",
    "data-name": "Rectangle 147926",
    width: 16.555,
    height: 1.685,
    transform: "translate(165.103 109.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147927",
    "data-name": "Rectangle 147927",
    width: 34.825,
    height: 1.685,
    transform: "translate(165.102 113.029)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147928",
    "data-name": "Rectangle 147928",
    width: 34.825,
    height: 1.685,
    transform: "translate(165.102 116.259)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147929",
    "data-name": "Rectangle 147929",
    width: 25.974,
    height: 1.685,
    transform: "translate(165.102 119.488)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147930",
    "data-name": "Rectangle 147930",
    width: 0.477,
    height: 23.107,
    transform: "translate(193.367 83.176)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147931",
    "data-name": "Rectangle 147931",
    width: 1.509,
    height: 0.953,
    transform: "translate(196.185 84.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147932",
    "data-name": "Rectangle 147932",
    width: 5.4,
    height: 0.953,
    transform: "translate(199.52 84.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147933",
    "data-name": "Rectangle 147933",
    width: 1.509,
    height: 0.953,
    transform: "translate(196.185 86.783)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147934",
    "data-name": "Rectangle 147934",
    width: 5.4,
    height: 0.953,
    transform: "translate(199.52 86.783)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147935",
    "data-name": "Rectangle 147935",
    width: 1.509,
    height: 0.953,
    transform: "translate(196.185 88.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147936",
    "data-name": "Rectangle 147936",
    width: 5.4,
    height: 0.953,
    transform: "translate(199.52 88.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147937",
    "data-name": "Rectangle 147937",
    width: 1.509,
    height: 0.953,
    transform: "translate(196.185 93.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147938",
    "data-name": "Rectangle 147938",
    width: 5.4,
    height: 0.953,
    transform: "translate(199.52 93.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147939",
    "data-name": "Rectangle 147939",
    width: 1.509,
    height: 0.953,
    transform: "translate(196.185 95.32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147940",
    "data-name": "Rectangle 147940",
    width: 5.4,
    height: 0.953,
    transform: "translate(199.52 95.32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147941",
    "data-name": "Rectangle 147941",
    width: 1.509,
    height: 0.953,
    transform: "translate(196.185 97.453)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147942",
    "data-name": "Rectangle 147942",
    width: 5.4,
    height: 0.953,
    transform: "translate(199.52 97.453)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147943",
    "data-name": "Rectangle 147943",
    width: 1.509,
    height: 0.953,
    transform: "translate(196.185 101.722)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147944",
    "data-name": "Rectangle 147944",
    width: 5.4,
    height: 0.953,
    transform: "translate(199.52 101.722)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147945",
    "data-name": "Rectangle 147945",
    width: 1.509,
    height: 0.953,
    transform: "translate(196.185 103.856)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147946",
    "data-name": "Rectangle 147946",
    width: 5.4,
    height: 0.953,
    transform: "translate(199.52 103.856)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38538",
    "data-name": "Path 38538",
    d: "M92.224,297.1c0,2.367-20.645,4.286-46.112,4.286S0,299.463,0,297.1s20.645-4.286,46.112-4.286,46.112,1.919,46.112,4.286",
    transform: "translate(0 -107.729)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38539",
    "data-name": "Path 38539",
    d: "M129.016,165.5l4.308-4.416a11.553,11.553,0,0,1,.384-2.385,10.96,10.96,0,0,1,1.143-2.121,1.561,1.561,0,0,1,.906,0,4.136,4.136,0,0,1,.867-.2,2.548,2.548,0,0,1,.771.245s.643-.044.912-.044a.575.575,0,0,1,.355.075,18.984,18.984,0,0,1,1.541-1.6c.5-.4,1.273-1.143,1.5-1.14s.31.381.154.783a4.476,4.476,0,0,1-.838,1.052l-1.963,2.974a4.212,4.212,0,0,0,.515-.246c.179-.112,1.375-1.23,1.448-1.275s.609-.4.922-.044-2.055,3.194-2.435,3.574a20.786,20.786,0,0,1-2.557,1.482s-2.3,4.134-2.522,4.4-5.409-1.118-5.409-1.118",
    transform: "translate(-47.467 -56.629)",
    fill: "#e49191"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38540",
    "data-name": "Path 38540",
    d: "M126.116,135.751s-2.406,13.939-4.671,14.262c0,0-9.041.365-11.056-10.6-1.747-9.513,5.26-11.541,8.537-10.814s7.893,1.2,7.19,7.155",
    transform: "translate(-40.512 -47.263)",
    fill: "#e49191"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38541",
    "data-name": "Path 38541",
    d: "M117.579,154.622s-1.267,1.708-1.711,5.844a13.428,13.428,0,0,1-7.237-1.25,51.181,51.181,0,0,0,2.1-12.167",
    transform: "translate(-39.967 -54.101)",
    fill: "#e49191"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38542",
    "data-name": "Path 38542",
    d: "M114.483,124.884c-4.941,1.092-4.546,4.17-4.546,4.17-2.313.573-2.81,1.528-2.791,5.8s1.564,9.4,2.416,9.814,5.682.437,6.086.291,2.093-4.064,1.7-4.753.02-3.4,1.145-3.5.9,1.641.9,1.641l.925-.2.714-1.751c6.529.389,8.216-7.052,8.216-7.052-1.568-1.023-9.828-5.545-14.769-4.453",
    transform: "translate(-39.42 -45.884)",
    fill: "#3a66b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38543",
    "data-name": "Path 38543",
    d: "M30.358,274.229l5,.722L33.7,280.785l-5.411-1.365a3.518,3.518,0,0,1,1.122-5.191,1.82,1.82,0,0,1,.947,0",
    transform: "translate(-10.145 -100.869)",
    fill: "#e5918f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38544",
    "data-name": "Path 38544",
    d: "M70.384,237.376l-7.364-22.3s-2.232-.8-3.375,0c0,0-7.671,4.125-6.852,15.887a192.206,192.206,0,0,0,3.248,22.34l-19.646-.726a6.693,6.693,0,0,0-.855,6.631s24.686,6.639,28.164,7.253c2.826.5,5.919.883,7.412-.4,2.631-2.254-.731-28.692-.731-28.692",
    transform: "translate(-12.881 -79.001)",
    fill: "#a0a9ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38545",
    "data-name": "Path 38545",
    d: "M67.16,274.229l5,.722L70.5,280.785,65.09,279.42a3.518,3.518,0,0,1,1.123-5.191,1.82,1.82,0,0,1,.947,0",
    transform: "translate(-23.685 -100.869)",
    fill: "#e5918f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38546",
    "data-name": "Path 38546",
    d: "M60.811,276.415c-.112,1.148.893,2.183.709,2.47s-3.542,5.92-3.542,5.92,2.535,1.1,2.126,2.7H53.683a5.327,5.327,0,0,1-1.636-3.681,18.626,18.626,0,0,1,1.581-4.7c1.145-2.208,3.748-7.194,3.748-7.194a3.635,3.635,0,0,1,2.14.041,12.981,12.981,0,0,1,3.106,1.389s-1.537.221-1.813,3.059",
    transform: "translate(-19.149 -99.998)",
    fill: "#8bf6f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38547",
    "data-name": "Path 38547",
    d: "M119.182,261.59c-1.585-5.915-16.5-31.167-21.547-37.986-10.364-4.5-21.409-8.319-21.409-8.319-4.569,1.091-6.818,10.3-4.227,16.433,1.777,4.21,13.054,14.805,19.959,21.044L72.8,252.739s-2.257,3.375-.212,6.579c0,0,31.871,7.246,34.666,7.656a63.536,63.536,0,0,0,9.069,0s4.2-.4,2.864-5.384",
    transform: "translate(-26.087 -79.206)",
    fill: "#c7d2d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38548",
    "data-name": "Path 38548",
    d: "M24.01,276.415c-.112,1.148.893,2.183.709,2.47s-3.542,5.92-3.542,5.92,2.535,1.1,2.126,2.7H16.882a5.327,5.327,0,0,1-1.636-3.681,18.626,18.626,0,0,1,1.581-4.7c1.145-2.208,3.748-7.194,3.748-7.194a3.635,3.635,0,0,1,2.14.041,12.981,12.981,0,0,1,3.106,1.389s-1.537.221-1.813,3.059",
    transform: "translate(-5.609 -99.998)",
    fill: "#8bf6f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38549",
    "data-name": "Path 38549",
    d: "M171.429,165.456l-10.278,18.08L153.79,176.2l-6.093,9.069,1.769.85-.637.53s14.205,6.918,15.908,5.392,9.634-24.527,9.634-24.527Z",
    transform: "translate(-54.34 -60.874)",
    fill: "#e49191"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38550",
    "data-name": "Path 38550",
    d: "M126.786,175.421s-1.941,8.186-5.822,12.066l-9.93-3.78s-4.608,7.749-9.115,13.691c-1.732,2.294-2.307,5.524-4.342,5.948-.126-.044-.247-.082-.373-.114-5.518-1.656-13.659.1-20.378-2.4-7.421-2.762-5.98-4.317-5.98-4.317a95.857,95.857,0,0,0,7.054-16.7,102.384,102.384,0,0,0,2.452-10.069,11.594,11.594,0,0,1,9.759-9.336c.057-.006.107-.019.164-.025,5.626-.714,20.353,1.024,23.217,2.25s13.293,12.781,13.293,12.781",
    transform: "translate(-26.024 -58.948)",
    fill: "#5aa0f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38551",
    "data-name": "Path 38551",
    d: "M126.659,196.612s-4.608,7.749-9.115,13.691c-1.732,2.294-2.307,5.524-4.342,5.948.891-.316,2.37-5.006,2.895-6.062s1.372-2.1,3.192-5.79,4.277-9.1,4.277-9.1Z",
    transform: "translate(-41.649 -71.853)",
    fill: "#3a66b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38552",
    "data-name": "Path 38552",
    d: "M104.213,274.463a17.127,17.127,0,0,1,9.905,1.423c-3.263-.575-6.615-.994-9.905-1.423",
    transform: "translate(-38.341 -100.907)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38553",
    "data-name": "Path 38553",
    d: "M192.578,153.043a9.686,9.686,0,0,0-1.728,1.247l.586-1.123a11.025,11.025,0,0,0,1.054-1.159c.279-.411.132-.822-.088-.844a8.643,8.643,0,0,0-1.619,1.158l.118-.226a11.071,11.071,0,0,0,1.054-1.16c.279-.411.132-.822-.088-.844a13.955,13.955,0,0,0-2,1.475L189,152.731l.655-1.272a5.505,5.505,0,0,0,.575-.881c.23-.46.064-.6-.064-.753s-1.328.741-1.635,1.1a18.474,18.474,0,0,0-1.353,2.011l-1,2.075c-.064-.6-.164-1.63-.236-2.286-.1-.945-.958-1.168-.987-.709a24.045,24.045,0,0,0-.4,3.945c.108,1.226.313,2.03.39,2.72a5.423,5.423,0,0,1-.638,2.067s2.86,1.776,3.333,1.245a22.284,22.284,0,0,0,1.966-2.507,13.336,13.336,0,0,0,1.119-2.528l.894-1.91a11.042,11.042,0,0,0,1.054-1.159c.279-.411.132-.822-.088-.844",
    transform: "translate(-67.807 -55.116)",
    fill: "#e49191"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38554",
    "data-name": "Path 38554",
    d: "M246.552,24.862h-5.134a.506.506,0,0,1,0-1.012h5.134a.506.506,0,0,1,0,1.012",
    transform: "translate(-88.635 -8.775)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38555",
    "data-name": "Path 38555",
    d: "M246.552,27.745h-5.134a.506.506,0,0,1,0-1.012h5.134a.506.506,0,0,1,0,1.012",
    transform: "translate(-88.635 -9.835)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38556",
    "data-name": "Path 38556",
    d: "M246.552,30.628h-5.134a.506.506,0,0,1,0-1.012h5.134a.506.506,0,0,1,0,1.012",
    transform: "translate(-88.635 -10.896)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38557",
    "data-name": "Path 38557",
    d: "M186.694,29.3H133.379a4.219,4.219,0,1,1,0-8.439h53.315a4.219,4.219,0,1,1,0,8.439",
    transform: "translate(-47.519 -7.674)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_481",
    "data-name": "Ellipse 481",
    cx: 2.244,
    cy: 2.244,
    r: 2.244,
    transform: "translate(134.067 14.869)",
    fill: "none",
    stroke: "#495ad6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_308",
    "data-name": "Line 308",
    x2: 1.239,
    y2: 1.239,
    transform: "translate(137.898 18.699)",
    fill: "none",
    stroke: "#495ad6",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertInProgressImage);
export default __webpack_public_path__ + "static/media/AlertInProgressImage.d7444afaccaa1804c573704b0177cbca.svg";
export { ForwardRef as ReactComponent };